import { z } from "zod"
import { emailSchema } from "../common/email-validator"

export const SuggestChangeSchema = z.object({
  category: z.string().min(1),
  description: z.string().min(1).max(500),
  email: emailSchema().optional(),
})

export type SuggestChange = z.infer<typeof SuggestChangeSchema>
